import { makeStyles } from '@material-ui/styles';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import useBoolean from 'common/hooks/useBoolean';

const useButtonStyles = makeStyles(
  theme => ({
    default: {
      ...theme.typography.body2,
      padding: '4px 16px',
      border: `1px solid ${theme.colors.gray5}`,
      backgroundColor: theme.colors.gray1,
      borderRadius: theme.borderRadius.min,
      ...theme.flex.crossCenter,
      cursor: 'pointer',

      '& > *:not(:first-child)': {
        marginLeft: 8,
      },

      '&:hover': {
        borderColor: theme.colors.mainGreen6,
      },
    },
    selected: {
      color: theme.colors.mainGreen6,
      boxShadow: theme.shadow.btn,

      '& svg': {
        color: theme.colors.mainGreen6,
        fill: theme.colors.mainGreen6,
      },
    },
    icon: {
      fontSize: '10px',
    },
    noBorder: {
      boxShadow: 'none',
      border: 0,
      background: 'none',

      '&:hover': {
        backgroundColor: theme.colors.gray3,
      },
    },
  }),
  { name: 'SelectButton' },
);

const SelectButton = ({
  onClick,
  selectedOption,
  noBtnBorder,
  btnText,
  filterIcon,
  showSelectedOption,
  hasOutlinedIcon = true,
  isSelected,
}) => {
  const classes = useButtonStyles();
  const [isOpenDropdown, { toggle: toggleIcon }] = useBoolean(false);

  const handleClickBtn = () => {
    onClick();
    toggleIcon();
  };

  return (
    <button
      className={classNames(classes.default, {
        [classes.selected]: !!selectedOption && isSelected,
        [classes.noBorder]: noBtnBorder,
      })}
      onClick={handleClickBtn}
    >
      {filterIcon}
      <Choose>
        <When condition={showSelectedOption && selectedOption?.text}>
          <span>{selectedOption?.text}</span>
        </When>
        <Otherwise>
          <span>{btnText}</span>
        </Otherwise>
      </Choose>

      <If condition={hasOutlinedIcon}>
        {isOpenDropdown ? (
          <UpOutlined className={classes.icon} />
        ) : (
          <DownOutlined className={classes.icon} />
        )}
      </If>
    </button>
  );
};

SelectButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedOption: PropTypes.string,
  noBtnBorder: PropTypes.bool,
  showSelectedOption: PropTypes.bool,
  btnText: PropTypes.string,
  hasOutlinedIcon: PropTypes.bool,
  filterIcon: PropTypes.object,
  isSelected: PropTypes.bool,
};

export default SelectButton;
